<template>
  <div class="dinput-checkbox">
    <sl-checkbox v-model="fieldValue.valor" />
  </div>
</template>

<script>
import Mixin from "@/reuse/input/dynamic/inputs/Mixin"
import SlCheckbox from "@/reuse/input/Checkbox"

export default {
  name: "DCheckbox",
  components: {SlCheckbox},
  mixins: [Mixin]
}
</script>
